import { Auth } from 'aws-amplify'
import { CognitoUserAttribute } from 'amazon-cognito-identity-js'

const ADMIN_USER_GROUP = 'click-frenzy-admin'

function getCurrentUser() {
    return Auth.currentAuthenticatedUser()
}

async function isUserAdmin(): Promise<boolean> {
    try {
        const user = await getCurrentUser()
        const groups = user.signInUserSession.accessToken.payload['cognito:groups']

        return groups.includes(ADMIN_USER_GROUP)
    } catch {
        return false
    }
}

function getAttributeByName(name: string, attributes: CognitoUserAttribute[]) {
    const attribute = attributes.find(attribute => attribute.getName() === name)

    return attribute ? attribute.getValue() : ''
}

export {
    getCurrentUser,
    isUserAdmin,
    getAttributeByName,
}
